import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { configOperations } from '../../redux/config';
import { mapOperations } from '../../redux/map';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import moment from 'moment';
import DetailRow from './DetailRow';
import RequiredFieldStatus from './RequiredFieldStatus';
import EditableAcreageTable from './EditableAcreageTable';
import {getFuelGroupForModel, getDefaultDateForField } from '../../utils/incidentHelper';
import originFields from '../../defaults/PointOfOriginFields.json'
import './DetailsIncidentPanel.css';

class DetailsIncidentPanel extends Component {
  constructor(props) {

    super(props);
    this.state = {
      open: true,
      highlightRequiredFields: false,
      primaryRequiredNullFields: [],
      requiredNullFields: [],
      derivingFields: [],
      secondaryRequiredNullFields: [],
      totalRequiredNullFields: null,
      requiredFields: props.requiredFields ? props.requiredFields : [],
      staticFields: props.staticFields ? props.staticFields : [],
      attributes: props.attributes,
      dependentFields: props.dependentFields ? props.dependentFields : []
    };
  }

  componentDidMount()
  {
    this.updateRequiredNullFields(this.props.attributes, this.state.requiredFields);
  }

  //TODO: Try to get rid of all componentWillReceiveProps
  componentWillReceiveProps(nextProps) {

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields === 0)
   {
     this.setState({
       open: false
     });
   }

   if (nextProps.panelCollapseState === true && this.state.totalRequiredNullFields > 0)
   {
     this.setState({
       open: true
     });
   }

    if (nextProps.expandAllPanels === true)
    {
      this.setState({
        open: true
      });
    }
    
   if(nextProps.requiredFields && this.props.requiredFields)
   {
     if (JSON.stringify({...nextProps.requiredFields}) !== JSON.stringify({...this.state.requiredFields}))
     {
       this.updateRequiredFields(nextProps.requiredFields);

       if(nextProps.attributes && this.props.attributes)
       {
           this.updateRequiredNullFields(nextProps.attributes, nextProps.requiredFields);
       }
     }
   }

    if(nextProps.attributes && this.props.attributes){
      if (JSON.stringify({...nextProps.attributes}) !== JSON.stringify({...this.props.attributes})) {
        this.updateRequiredNullFields(nextProps.attributes, nextProps.requiredFields);
      }
    }
  }

resetAcreageRecalc = () => 
{
  this.props.onResetAcreageRecalc();
}

updateRequiredFields = (updatedRequiredFields) =>
{
  this.setState({
    requiredFields: updatedRequiredFields
  });
}

  updateRequiredNullFields = (attributes, requiredFields) => {

    if (!requiredFields)
    {
      return;
    }
    if(!attributes) {
      console.warn('missing argument');
      return;
    }
    if(!attributes) {
      console.warn('missing argument');
      return;
    }
    //get null required fields
    //count in primary
    let primaryRequiredNullFields = [];
    this.props.primaryFields.forEach(fieldName => {
      const fieldVal = attributes[fieldName];
      const isRequired = requiredFields.includes(fieldName);
      if (isRequired && (fieldVal === undefined || fieldVal === null || this.props.validationInfo.invalidFields.includes(fieldName))) {
        primaryRequiredNullFields.push(fieldName)
      }
    });

    //count in secondary
    let secondaryRequiredNullFields = [];
    this.props.secondaryFields && this.props.secondaryFields.forEach(fieldName => {
      const fieldVal = attributes[fieldName];
      const isRequired = requiredFields.includes(fieldName);
      if (isRequired && (fieldVal === undefined || fieldVal === null || this.props.validationInfo.invalidFields.includes(fieldName))) {
        secondaryRequiredNullFields.push(fieldName)
      }
    });

    let requiredNullFields = [];
    this.props.fields.forEach(fieldName => {
      const fieldVal = attributes[fieldName];
      const isRequired = requiredFields.includes(fieldName);
      if (isRequired && (fieldVal === undefined || fieldVal === null || this.props.validationInfo.invalidFields.includes(fieldName))) {
        requiredNullFields.push(fieldName)
      }
    });

    //total count
    const totalRequiredNullFields = primaryRequiredNullFields.length + secondaryRequiredNullFields.length;
    this.setState({
      primaryRequiredNullFields,
      secondaryRequiredNullFields,
      totalRequiredNullFields,
      requiredNullFields
    })
  }

getDependentAttribute = (fieldName) =>
{
  switch (fieldName)
  {
    case originFields.incidentTypeCategory:
      return  originFields.incidentTypeKind;

    case originFields.landownerCategory:
      return  originFields.landownerKind;

    case originFields.predominantFuelModel:
      return  originFields.predominantFuelGroup;

      case originFields.fireCauseGeneral:
        return originFields.fireCause;

    default:
      return null;
  }
}

setDerivingFor = (fieldName) =>
{
  let currentDerivingFields = this.state.derivingFields;

  if (!currentDerivingFields.includes(fieldName))
  {
    currentDerivingFields.push(fieldName);
    this.setState({
      derivingFields: currentDerivingFields
    });
  }
}

stopDerivingFor = (fieldName) =>
{
    let currentDerivingFields = this.state.derivingFields;

    if (currentDerivingFields.includes(fieldName))
    {
      currentDerivingFields = currentDerivingFields.filter(name => name !== fieldName);
      this.setState({
        derivingFields: currentDerivingFields
      });
    }
}

deriveValue = (fieldName) =>
{

  if (fieldName === originFields.predominantFuelModel)
  {
      this.setDerivingFor(fieldName);
      window.api.deriveFuelModel(this.state.attributes["_pointGeometryLatitude"], this.state.attributes["_pointGeometryLongitude"], this.state.attributes[originFields.state], this.props.map.currentExtent).then(response =>
        {
            const fuelGroup = getFuelGroupForModel(response);
            this.props.onDeriveSetUpdated([originFields.predominantFuelGroup, originFields.predominantFuelModel], [fuelGroup, response]);
            this.stopDerivingFor(fieldName);
        });
  }

  if (fieldName === originFields.landownerCategory)
  {
      this.setDerivingFor(fieldName);
      window.api.deriveLandownerCategory(this.state.attributes["_pointGeometryLatitude"], this.state.attributes["_pointGeometryLongitude"]).then(response =>
        {
            this.props.onDerivedPropUpdated(originFields.landownerCategory, response.LandownerCategory);
            this.props.onDerivedPropUpdated(originFields.landownerKind, response.LandownerKind);
            this.stopDerivingFor(fieldName);
        });
  }

  if (fieldName === originFields.calculatedAcres)
  {

    let perimeterToDerive = (this.props.editablePerimeter && this.props.editablePerimeter.geometry) ? this.props.editablePerimeter : this.props.perimeter;
    if (perimeterToDerive !== null)
    {
        this.setDerivingFor(fieldName);
        window.api.deriveCalculatedAcres(perimeterToDerive).then(response =>
        {
            this.props.onDerivedPropUpdated(originFields.calculatedAcres, response);
            this.stopDerivingFor(fieldName);
        });
      }
    }
}
getDomainForOverrideField = (name) => 
{
  switch (name) {
    case "FeatureStatus":
      return {
        codedValues: [
          {
            name:"Approved",
            code:"Approved"
         },
         {
            name:"In Review",
            code:"In Review"
         },
         {
            name:"Proposed",
            code:"Proposed"
         },
         {
            name:"Archive",
            code:"Archive"
         }
        ]
      };
    case "DeleteThis":
      return {
        codedValues: [
          {
            name:"No",
            code:"No"
         },
         {
            name:"Yes - No Longer Needed",
            code:"Yes - No Longer Needed"
         },
         {
            name:"Yes - Editing Mistake",
            code:"Yes - Editing Mistake"
         }
        ]
      };
    case "FeatureAccess":
      return {
        codedValues: [
          {
            name:"Public",
            code:"Public"
         },
         {
            name:"Cooperators",
            code:"Cooperators"
         },
         {
            name:"Incident",
            code:"Incident"
         },
         {
          name:"Restricted",
          code:"Restricted"
       },
       {
          name:"Unknown",
          code:"Unknown"
       }
        ]
      };
  }
}
  generateJurisdictionalAcresTable = (jurisdictionalAcres) =>
  {
      /*const divContent =  jurisdictionalAcres.map(option => {
        return <span key={option.attributes} value={option.code} primaryText={option.code} />
      })*/
      return (
        <div className="detail-row" key="jurisdictionalAcres">
        <label className="detail-row-label">Acres by Jurisdiction</label>
        <div className="detail-row-value" key="jurisdictionalAcresLabel">
          <span>
          <Table>
          <TableHead>
           <TableRow>
             <TableCell style={{color: "#6495ED", fontWeight:"bold"}}>Agency</TableCell>
             <TableCell align="left" style={{color: "#6495ED", fontWeight:"bold"}}>Unit</TableCell>
             <TableCell align="left" style={{color: "#6495ED", fontWeight:"bold"}}>Unit ID</TableCell>
             <TableCell align="left" style={{color: "#6495ED", fontWeight:"bold"}}>Acres</TableCell>
           </TableRow>
         </TableHead>
         <TableBody>
           {jurisdictionalAcres.map((row) => (
             <TableRow key={row.attributes.GlobalID}>
               <TableCell component="th" scope="row">
                 {row.attributes.JurisdictionalAgency}
               </TableCell>
               <TableCell align="left">{row.attributes.JurisdictionalUnit}</TableCell>
               <TableCell align="left">{row.attributes.JurisdictionalUnitID}</TableCell>
               <TableCell align="left">{row.attributes.JurisdictionAcres}</TableCell>
             </TableRow>
           ))}
         </TableBody>
       </Table>
       </span>
        </div>
      </div>);
  }

  generateDetailRows = (fields, isPrimary) => {

    if (this.props.key === "Size") 
    {
      debugger;
      console.log("Size panel generateDetailRows");
    }
    let fieldInfos = this.props.fieldInfos;

    if (fieldInfos === null || fields === null)
    {
       return;
    }

    const isFA = this.props.attributes[originFields.incidentTypeCategory] === "FA";

    return fields.map(field => {
      let fieldInfo = fieldInfos.filter(fieldInfo => {
        return fieldInfo.name === field
      })

      fieldInfo = fieldInfo[0]

      if (fieldInfo)
      { 
        let isDerivable = (fieldInfo.name === originFields.predominantFuelModel || fieldInfo.name === originFields.landownerCategory || fieldInfo.name === originFields.calculatedAcres );
        let canPerformADSWrite = true;
        if ((this.props.adsStatus !== null && this.props.adsStatus !== undefined) && this.props.adsStatus.hasOwnProperty(fieldInfo.name))
        {
            canPerformADSWrite = this.props.adsStatus[fieldInfo.name].canWrite;
        }

        //disable some stuff for FA
        if (isFA && fieldInfo.name === originFields.incidentSize) 
        {
          canPerformADSWrite = false;
        }
        const isRequired = this.state.requiredFields.includes(fieldInfo.name);
        const isDependent = this.state.dependentFields.includes(fieldInfo.name);
        const isStatic = this.state.staticFields.includes(fieldInfo.name);
        const isDeriving = this.state.derivingFields.includes(fieldInfo.name);
        const showUnitValidator = this.props.unitValidatorFields.includes(fieldInfo.name);
        const overridePerimeterFieldInfo = (this.props.isPerimeter && this.props.overrideDomainFields.includes(fieldInfo.name));

        if (overridePerimeterFieldInfo) 
        {
          fieldInfo.domain = this.getDomainForOverrideField(fieldInfo.name)  //this.props.overrideDomainFields[fieldInfo.name] ;
        }
        return <DetailRow
          key={fieldInfo.name}
          fieldInfo={fieldInfo}
          attributes={this.props.attributes}
          knownUnitIds={this.props.knownUnitIds}
          mode={this.props.mode}
          canPerformADSWrite={canPerformADSWrite}
          isDerivable={isDerivable}
          isDeriving={isDeriving}
          onDeriveValue={(isDerivable) ? this.deriveValue : null}
          isPrimary={isPrimary}
          isRequired={isRequired}
          showUnitValidator={showUnitValidator}
          isDependent={isDependent}
          dependentAttribute={(isDependent) ? this.getDependentAttribute(fieldInfo.name) : null}
          isStatic={isStatic}
          fieldInfos={fieldInfos}
          validationType={this.props.validationType}
          validationInfo={this.props.validationInfo}
          highlightRequiredFields={this.state.highlightRequiredFields}
          onAgencyValidated={(fieldName, agencyVal) => {
            this.props.onAgencyValidated(fieldName, agencyVal)
          }}
          onUpdateProp={(fieldName, newVal) => {
            this.props.onPropUpdated(fieldName, newVal)
          }}
          defaultDate={getDefaultDateForField(fieldInfo.name, this.props.attributes)}  />
      }
      else
      {
        //This is not ideal.
        if (field === "PerimeterSource" && this.props.perimeter.Feature.PerimeterSource && this.props.perimeter.Feature)
        {
          return (
            <div className="detail-row" key="PerimeterSource">
            <label className="detail-row-label">Perimeter Source</label>
            <div className="detail-row-value" key="PerimeterSourceLabel">
              <span>{this.props.perimeter.Feature.PerimeterSource}</span>
            </div>
          </div>
        )
      } 
      else if (field === "InformLastModifiedDate")
      {
        return (
          <div className="detail-row" key="InformLastModifiedDate">
          <label className="detail-row-label">InFORM Last Modified Date</label>
          <div className="detail-row-value" key="InformLastModifiedDateLabel">
            <span>{moment(this.props.attributes[originFields.informLastModifiedDate]).format(this.props.appConfig.timeDateFormat)}</span>
          </div>
        </div>
      )
    }
      else
      {
        return "";
      }
      }
    })
  }

  highlightRequiredFields = () => {
    const open = this.state.open || (this.state.secondaryRequiredNullFields.length > 0);
    this.setState({
      open,
      highlightRequiredFields: true
    }, () => {
      window.setTimeout(() => {
        this.setState({highlightRequiredFields: false})
      }, 1000);
    });
  }

  accordionChange = (event) => {
    this.setState({open: !this.state.open});
    this.props.resetPanelCollapseFlag();
  }

  render() {

    if (this.props.key === "Size") {
      console.log("Size panel render");
    }

    let detailRows;
    let acreageTable = (this.state.open && this.props.isPerimeter) ? (
        <EditableAcreageTable
            mode={this.props.mode}
            shouldDisable={this.props.shouldDisableForFA}
            perimeter={this.props.perimeter}
            fireOccurenceRecordID={this.props.fireOccurenceRecordID}
            perimeterWasRecalced={this.props.perimeterWasRecalced}
            perimeterAcreage={this.props.acresByOwnership}
            clientDerivedPolygonAcres={this.props.clientDerivedPolygonAcres}
            isRecalculatingAcres={this.props.isRecalculatingAcres}
            onUpdateAcreageProp={(num, index) => {
              this.props.onAcreagePropUpdated(num, index)
            }}
            resetAcreageRecalc={() => { this.resetAcreageRecalc() }}
            onAcreageRemoved={(index) => {
              this.props.onAcreagePropRemoved(index)
            }}
            onRecalculate={() =>
              {
              this.props.onAcreageRecalculate()
            }}
            onAddNewRow={() =>
              {
              this.props.onAddNewAcreageRow()
            }}
            acreageLandownerCategoryUpdated={(index, value) => {
              this.props.onAcreageLandownerCategoryUpdated(index, value)
            }}
            />) : "";

    if (this.state.open)
    {
      detailRows = this.generateDetailRows(this.props.fields);
    }

    let expanderContent;
      expanderContent = (
        <div className="incident-details-panel-expander">
            {detailRows}
            {acreageTable}
        </div>
      )

    let requiredFieldStatusNode = '';
    if (this.state.totalRequiredNullFields > 0)
    {
      requiredFieldStatusNode = (
        <RequiredFieldStatus
          chipClicked={this.highlightRequiredFields}
          missingFields={this.state.totalRequiredNullFields} />
      )
    }

    let title = (
      <div className="incident-details-panel-header">
        <h4>{this.props.title}</h4>
        <span className="required-field-node-class">{requiredFieldStatusNode}</span>
      </div>
    )

    return (
      <Accordion className="incident-details-panel" expanded={this.state.open} onChange={this.accordionChange}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>{title}</AccordionSummary>
        <AccordionDetails>{expanderContent}</AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  appConfig: state.config,
  map: state.map
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...configOperations,
    ...mapOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailsIncidentPanel)
